export function userLanguage(): string {
  try {
    const lang = window.navigator['userLanguage'] || window.navigator.language;
    return lang.substring(0, 2);
  } catch (e) {
    return 'en';
  }
}
